import React from "react";
import {API_URL} from "../../constants";
import {makeRequest} from "../../services/requestService";
import PropTypes from "prop-types";
import PivanCard, {PivanCardSkeleton} from "./PivanCard";

PageCard.propTypes = {
    page: PropTypes.shape({
        id: PropTypes.number.isRequired,
        viewing: PropTypes.string.isRequired
    }),
    imgSrc: PropTypes.string.isRequired,
    hideImg: PropTypes.bool
}

PageCard.defaultProps = {
    hideImg: false
}

export default function PageCard(props) {
    const {page, imgSrc, hideImg} = props;
    const [text, setText] = React.useState([]);
    const [loaded, setLoaded] = React.useState(false);
    const img = {
        src: imgSrc,
        title: page.viewing
    }

    React.useEffect(() => {
        makeRequest(`${API_URL}/texts/bypage/${page.id}?page=0&size=1`).then((response) => {
            if (response.status === 200) {
                if (Array.isArray(response.data.data)) {
                    let firstText = response.data.data[0];
                    if (firstText) {
                        setText(firstText.cachedContent);
                        setLoaded(true);
                    }
                }
            }
        });
    }, [page]);

    if (!loaded) return <PivanCardSkeleton/>

    return (
        <PivanCard
            title={page.viewing}
            description={text}
            target={`/page/${page.id}`}
            img={img}
            hideImg={hideImg}
        />
    );
}